"use client";

export { default } from "../../src/app/planner/error";
